var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6909 2.14545C5.0837 2.14545 2.14545 5.08371 2.14545 8.69091C2.14545 12.2981 5.0837 15.2364 8.6909 15.2364C10.2595 15.2364 11.7001 14.6793 12.8291 13.7547L16.7372 17.6628C16.7975 17.7256 16.8698 17.7758 16.9497 17.8103C17.0296 17.8449 17.1157 17.8631 17.2027 17.864C17.2898 17.8649 17.3762 17.8484 17.4568 17.8155C17.5375 17.7825 17.6107 17.7339 17.6723 17.6723C17.7339 17.6107 17.7825 17.5375 17.8155 17.4568C17.8484 17.3762 17.8649 17.2898 17.864 17.2028C17.8631 17.1157 17.8448 17.0296 17.8103 16.9497C17.7757 16.8698 17.7256 16.7975 17.6628 16.7372L13.7547 12.8291C14.6793 11.7001 15.2364 10.2595 15.2364 8.69091C15.2364 5.08371 12.2981 2.14545 8.6909 2.14545ZM8.6909 3.45455C11.5906 3.45455 13.9273 5.79119 13.9273 8.69091C13.9273 11.5906 11.5906 13.9273 8.6909 13.9273C5.79118 13.9273 3.45454 11.5906 3.45454 8.69091C3.45454 5.79119 5.79118 3.45455 8.6909 3.45455Z",
    fill: "#FFB670"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierColor);
export default __webpack_public_path__ + "static/media/Magnifier-color.ea913b3c4807df9ee44e2a0dcf36f7d8.svg";
export { ForwardRef as ReactComponent };